import conference from "../images/Rectangle 19.png"
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid'
import { Link } from "react-router-dom";

export default function Carousel() {
    return (
        <div className=" bg-background">
            <div className="mx-auto w-screen h-99 flex-shrink-0 sm:px-6 lg:px-8">
                
                <div className="relative flex">
                    <img
                        src={conference}
                        className="absolute object-cover object-center"
                    />
                    <div className="relative mb-3 flex w-full flex-col items-start justify-end bg-black bg-opacity-40 p-8 sm:p-12">

                        <div className="mt-40 pt-40">
                            <h2 className="text-4xl font-title font-bold text-white">ICP Asia Launch Event</h2>
                            <p className="mt-2 mb-4 text-base font-text text-white">Thursday, September 28 | Hong Kong, Hong Kong</p>
                            <Link
                                to='/purchase'
                                className="mt-4 rounded-md bg-blue px-4 py-2.5 text-sm font-text text-white"
                            >
                            Purchase Tickets
                            </Link>
                        </div>

                    </div>
                    <div className="relative mb-3 flex w-full flex-col items-end justify-end bg-black bg-opacity-40 p-8 sm:p-12">

                        <div className="mt-40">
                            <Link
                                to='/purchase'
                                className="mt-4 rounded-md bg-blue px-4 py-2.5 text-sm font-text text-white"
                            >
                            Purchase Tickets
                            </Link>
                        </div>

                    </div>


                </div>
            </div>

        </div>

    )
}
